'use client';

import type React from 'react';
import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import fontsStyles from '../../../../styles/modules/fonts.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryDrawResult } from '../../types';
import styles from './LotteryDrawAnime.module.scss';
import { useLotteryDrawAnime } from './hooks/useLotteryDrawAnime';

export type LotteryDrawAnimeProps = {
  lotteryDrawResult: LotteryDrawResult;
  isFromFamipay?: boolean;
};

function LotteryDrawAnime({ lotteryDrawResult, isFromFamipay = false }: LotteryDrawAnimeProps) {
  const { scene, gifUrl, maxRank, currentGoods, goResult, nextGoods, isShowLogo, currentGoodsIndex, goodsList } =
    useLotteryDrawAnime(lotteryDrawResult, isFromFamipay);

  return (
    <>
      {scene === 1 && (
        <div className={`${styles.sceneContainer} ${styles.scene1}`} style={{ backgroundImage: gifUrl }}>
          {isShowLogo && <img className={styles.logo} src='/logo.png' alt='Loading' />}
        </div>
      )}
      {/* ハズレではない場合、レンダリングをしておかないとアニメーションが動かないため、display:noneで非表示にしている */}
      {maxRank !== '-1' && (
        <div className={`${styles.sceneContainer} ${styles.scene2}`} style={{ display: scene === 1 ? 'none' : 'flex' }}>
          <div className={styles.imageFlash} />
          <div className={`${styles.imageBackground} ${styles[`rank${currentGoods().stagingRank}`]}`} />
          {/* テキスト、画像、ボタン */}
          <div className={styles.sceneFront}>
            <div
              className={`${styles.textCongrats} ${fontsStyles.montserrat} ${utilsStyles.textBold}`}
              id='textCongrats'
            >
              Congrats!
            </div>
            <div className={styles.imageWrapper} id='imageWrapper'>
              <img src={currentGoods().imageUrl} alt='景品' />
              {/* 演出 */}
              <div className={`${styles.stagingRank} ${styles[`rank${currentGoods().stagingRank}`]}`} />
              <div className={`${styles.stagingText} ${fontsStyles.montserrat}`}>
                {currentGoods().stagingText}
                <small>賞</small>
              </div>
            </div>

            <div className={`${styles.goodsDetail} ${utilsStyles.textBold} footInfo`} id='goodsDetail'>
              <p className={styles.goodsName}>{currentGoods().name}</p>
              <output className={styles.goodsIndex}>
                {currentGoodsIndex + 1} / {goodsList.length}
              </output>
            </div>
            <div className={`${styles.buttonArea} footInfo`} id='buttonArea'>
              <ActionButton color='black' onClick={nextGoods}>
                次へ
              </ActionButton>
              <button type='button' className={`${utilsStyles.textBold} ${styles.skipButton}`} onClick={goResult}>
                スキップ
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default LotteryDrawAnime;
